module.exports = new __parcel__URL__("10438252-2.87b1cd7f.png").toString();